import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Col from 'react-bootstrap/lib/Col';

import ValidatedField from '../form/ValidatedField';
import PureRenderComponent from '../PureRenderComponent';
import t from "../../lib/I18n";

class Isrn extends PureRenderComponent {

    static propTypes = Object.assign({
        label: PropTypes.string.isRequired,
        validation: PropTypes.object
    }, _.pick(ValidatedField.propTypes, [
        'id',
        'form',
        'onChange',
        'required',
        'disabled',
        'visited',
        'validation',
        'field'
    ]));

    render () {
        return (
            <Col md={ 12 }>
                <ValidatedField
                    { ...this.props }
                    type="text"
                    name={ this.props.id }
                    placeholder={ t('account.smartcardsignup.isrn.placeholder') }
                    labelClassName="sr-only"
                />
            </Col>
        );
    }
}

export default Isrn;



// WEBPACK FOOTER //
// ./src/components/customer/Isrn.js